import React from 'react';
import './Sections.scss';

function Section6() {
  return (
    <section className="sections sections-section6">
      <p className="sections-copy">
        But what happens now that the pandemic is coming to an end? Dr. Lautz thinks it’s unlikely
        that we’ll simply turn back the clock to pre-pandemic workplace norms. “As the pandemic
        recedes, we are seeing employers struggling to retain good talent,” she says. “If they want
        to keep those employees, they are going to have to be flexible with work-from-home policies.
        Accordingly, I think many CEOs are allowing people to work flexibly and remotely, which will
        give home buyers the ability to move wherever they want to be.”
      </p>
      <p className="sections-copy">
        As remote and hybrid work become more normative for large segments of the population, look
        for home buyers to continue favoring spacious properties with features such as home offices
        that can accommodate a work-from-home lifestyle.
      </p>
    </section>
  );
}

export default Section6;
